<template>
  <div class="p-grid fix">
            <p class="goods-code"><span class="code-bottom"><span>编号:</span><span>{{item.productCode}}</span></span></p>

            <div class="pic">
              <router-link :to="`/product/${item.merchantCode}/${item.productCode}`">
                <img v-if="item.imageUrl" :src="item.imageUrl" :alt="item.productName">
                <img v-else src='../assets/no-picture.png' :title="item.productName"/>
              </router-link>
            </div>
              
            <p class="p-name w-s-b" :title="item.productName">
              <router-link :to="`/product/${item.merchantCode}/${item.productCode}`">
                {{item.productName}}
              </router-link>
            </p>

            <div class="sales">
              <span class="d-ib" :class="{'is-err': num > item.stock || item.stock == 0}">库存{{ item.stock }}{{ item.saleUnit}}</span>

              <span v-if="item.auditStatus != 2 || item.status == 20 " class="sales-volume">{{ item.auditStatus != 2 ? '已失效' : item.status == 20 ? '已下架' : ''}}</span>

              <span v-if="item.status != 20 && item.auditStatus == 2 && item.stock > 0 && item.isLimited === '100'"  class="d-ib"  :class="{'is-err': num > item.remainedQuantity || item.remainedQuantity == 0 }">{{ '限购 ' + item.remainedQuantity + item.saleUnit }}</span>

            </div>

            <div class="b-price">
              <IconJifen size="mini" :points="item.price" />
              <div v-if="item.stock != 0" class="gift-btn">
                <InputNum v-model="num" :id="item.id" :merchantCode="item.merchantCode" :productCode="item.productCode" size="mini" :min="0" :max="999"/>
              </div>
              <div v-else class="gift-btn-s">暂时缺货</div>
            </div>
          </div>
</template>

<script>
import InputNum from "./input-num";
import IconJifen from "./icon-jifen";
export default {
  name: "PItem",
  components: {
    InputNum,
    IconJifen
  },
  props: {
    item: {}
  },
  data() {
    return {
      num: this.item.quantity || 0
    };
  },
  watch: {
    "item.quantity": {
      immediate: true,
      handler(value) {
        this.num = value;
      }
    }
  },
  computed: {
    quantity() {
      return this.item.quantity;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.gift-btn-s {
  border: 2px solid #cfcfd2;
  display: inline-block;
  border-radius: 60px;
  height: 26px;
  width: 90px;
  text-align: center;
  font-size: 14px;
  overflow: hidden;
  padding: 0;
  outline: 0;
  line-height: 26px;
  color: #cfcfd2;
  float: right;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
